// The room you are standing in, as something to raycast against.
//
// A plain module object rather than store state on purpose: it holds a live
// three.js object, it changes only when you enter or leave a room, and FloorClamp
// reads it every frame. Putting an Object3D in the store would re-render every
// subscriber on a room change for a value none of them can use.
export const interiorFloor = { object: null };

export function setInteriorFloor(object) { interiorFloor.object = object || null; }

// ROOM SPACE — the room's own coordinate system, as an object you can convert
// against.
//
// This is MeshInterior's anchor group: the room's position (its city anchor plus
// any Y nudge) and its yaw, with the fit scale applied further down so this stays
// RIGID. Rigid matters — a placement converted through it keeps its size in world
// units, so nothing downstream has to know about a second unit system.
//
// It exists so that anything living in a room can be STORED relative to the room
// rather than to the world. A virtual room is instanced at world origin, which
// makes the two look identical right up until the room moves, gets nudged, or is
// anchored to a different building — at which point everything authored in world
// coordinates stays behind. Portals and interior residents already render inside
// this group; placements now do too, and are saved in its space.
//
// A live Object3D rather than store state, for the same reason as interiorFloor
// above: it changes only when you enter or leave a room, and putting an Object3D
// in the store would re-render every subscriber for a value none of them can use.
export const roomSpace = { object: null };

export function setRoomSpace(object) { roomSpace.object = object || null; }
